import React from "react";
import CopyRight from "../../../../elements/CopyRight";
import SocialMediaIcons from "./components/SocialMediaIcons";
import CompanyMotto from "./components/CompanyMotto";

export default function FooterBottom({ socialMediaIcons }) {
  
  return (
    <div className="border-t border-[#4284FF] flex-row lg:flex justify-between items-center pt-4 ">
      <div className="flex divide-none gap-4 text-sm justify-between lg:justify-center items-center">
        <div className="md:block hidden">
          <CopyRight />
        </div>
        <div className="md:hidden block">
          <CompanyMotto />
        </div>
        <SocialMediaIcons socialMediaIcons={socialMediaIcons} />
      </div>
      <div className="flex divide-x border-[#4284FF] space-x-5 divide-[#4284FF] sm:order-2 pt-5 md:pt-0">
        <div className="md:hidden block  justify-center items-center mx-auto">
          <CopyRight />
        </div>
        <div className="md:block hidden">
          <CompanyMotto />
        </div>
      </div>
    </div>
  );
}
